import Style from "../../../../../css/style.module.css";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";

const DeskBoxArea = (props: any) => {
  let myProps: any = {
    x: 0,
    y: 0,
    room_info: null,
    desk_info: null,
    desku_info: null,
    now_ymdhis: "",
    pre_date_str: "",
    now_lecture_data: null,
    select_stu_data: {},
    dragged_desku_info: null,
    set_dragged_desku_info: (inData: any) => { },
    go_move_desku_info_by_ajax: (inData: any) => { },
    student_info_arr: [],
    open_find_stu_popup: (inData: any) => { },
    open_view_desk_popup: (inData: any) => { },
    open_select_stu_alloc_desk_popup: (inData: any) => { },
    ...props
  };
  if (myProps.now_ymdhis == "") {
    myProps.now_ymdhis = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
  }
  let now_date_json = DateFunc.get_date_json(new Date(myProps.now_ymdhis));
  let now_sec = now_date_json.date_obj.getTime() / 1000;
  let desk_info = myProps.desk_info;
  let desku_info = myProps.desku_info;
  let dragged_desku_info = myProps.dragged_desku_info;
  let desk_box_class_name: any = Style.desk_box;
  let desk_num_str = "";
  let desk_per_height = "0%";
  if (desk_info != null) {
    desk_num_str = desk_info["a_name"];
  } else {
    desk_box_class_name += " " + Style.desk_empty_area;
  }

  let desk_use_time_data = DeskUseDataFunc.get_desk_use_time_data({
    now_ymdhis: myProps.now_ymdhis,
    desku_info: desku_info,
  });

  let user_name = "";//홍길동
  let remain_minute_num = desk_use_time_data.remain_minute_num;
  let elapse_minute_num = desk_use_time_data.elapse_minute_num;
  let time_period = desk_use_time_data.time_period;//21:00 ~ 22:30
  let percent_num = desk_use_time_data.percent_num;
  let is_target_time = desk_use_time_data.is_target_time;
  let per_num = desk_use_time_data.per_num;
  let per_target_num = desk_use_time_data.per_target_num;
  let desk_back_class_name = Style.desk_back_per;
  let stu_info: any = null;
  if (desku_info != null) {
    user_name = desku_info["a_user_name"];
    if (remain_minute_num < 5 && per_num < per_target_num) {
      desk_back_class_name += " " + Style.is_ending;
    }
    if(percent_num>=100&&is_target_time==false&&desku_info["a_is_finnish"]!="1"){
      desk_back_class_name += " " + Style.is_not_finnish;
    }
    desk_per_height = percent_num + "%";
    for (let i = 0; i < myProps.student_info_arr.length; i++) {
      if (myProps.student_info_arr[i].a_seq == desku_info["a_user_seq"]) {
        stu_info = myProps.student_info_arr[i];
        break;
      }
    }
  }

  let content_box_class_name = Style.desk_content_box;
  let content_box_style: any = {};
  if (desku_info != null) {
    content_box_class_name += " " + Style.is_use_desk;
  }

  const open_view_desk_popup = () => {
    if (desku_info == null) {
      return false;
    }
    myProps.open_view_desk_popup({
      room_info: myProps.room_info,
      desk_info: desk_info,
      desku_info: desku_info,
      now_ymdhis: myProps.now_ymdhis,
      now_lecture_data: myProps.now_lecture_data,
    });
  };

  const on_dragg_start = () => {
    if (desku_info != null) {
      myProps.set_dragged_desku_info({ ...desku_info });
    }
  };
  const on_drop_dragged = () => {
    if (dragged_desku_info != null) {
      if (desk_info != null) {
        if (desk_info.a_is_able_use == "1") {
          if (dragged_desku_info.a_room_seq == myProps.room_info.a_seq) {
            myProps.go_move_desku_info_by_ajax({
              "desku_info": { ...dragged_desku_info },
              "target_desk_info": desk_info,
              "room_info": myProps.room_info,
            });
          }
        }
      }
      myProps.set_dragged_desku_info(null);
    }
  };

  const get_find_stu_desk_box_button = () => {
    let find_btn_str: any = "";
    if (desk_info != null) {
      if (desk_info.a_is_able_use != "1") {
        find_btn_str = (
          <div className={Style.desk_user_find_wrap3}>
            <div className={Style.desk_user_find_wrap3_con}>
              <span className={Style.desk_user_find_wrap3_x}>
                &times;
              </span>
              <div style={{ fontSize: "13px", position: "absolute", bottom: 0, textAlign: "center", width: "100%" }}>
                {desk_info.a_able_memo}
              </div>
            </div>
          </div>
        );
      } else if (myProps.select_stu_data.is_select) {
        find_btn_str = (
          <div
            className={Style.desk_user_find_wrap}
            onClick={() => {
              myProps.open_select_stu_alloc_desk_popup({
                "room_info": myProps.room_info,
                "desk_info": desk_info,
                "now_ymdhis": myProps.now_ymdhis,
                "now_lecture_data": myProps.now_lecture_data,
              });
            }}>
            <div className={Style.desk_user_find_wrap_con}>
              <div className={Style.desk_user_find_wrap2}>
                {desk_num_str} 번
                <div>
                  선택
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        find_btn_str = (
          <div className={Style.desk_user_find_wrap}
            onClick={() => {
              myProps.open_find_stu_popup({
                "room_info": myProps.room_info,
                "desk_info": desk_info,
                "now_ymdhis": myProps.now_ymdhis,
                "now_lecture_data": myProps.now_lecture_data,
              });
            }}>
            <div className={Style.desk_user_find_wrap_con}>
              <button className="btn btn-dark"
                style={{ minWidth: "30px", minHeight: "30px" }}>+</button>
            </div>
          </div>
        );
      }
    }
    return find_btn_str;
  };

  const get_desk_use_div = () => {
    let desk_use_div: any = "";
    if (desku_info != null) {
      desk_use_div = (
        <>
          <div className={Style.desk_per_div}>
            <span className={Style.desk_per_div_num}>
              {is_target_time ? remain_minute_num : elapse_minute_num}
            </span>
            분
          </div>
          <span className={Style.desk_user_name}>{user_name}</span>
          <div className={Style.desk_time_period}>
            {is_target_time ? time_period : time_period.substring(0, 5) + "~"}
          </div>
        </>
      );

    }
    return desk_use_div;
  };

  return (
    <div className={desk_box_class_name}
      onTouchStart={(e: any) => {
        //on_dragg_start();
      }}
      onDragStart={(e: any) => {
        on_dragg_start();
      }}
      onDragOver={(e: any) => {
        e.preventDefault();
      }}
      onDrop={(e: any) => {
        on_drop_dragged();
      }}
      onTouchEnd={(e: any) => {
        //on_drop_dragged();
      }}
      draggable={desku_info != null ? "true" : "false"} >
      <div className={desk_back_class_name} style={{ height: desk_per_height }}></div>
      <div className={content_box_class_name}
        style={content_box_style}
        onClick={(e: any) => {
          open_view_desk_popup();
        }}
      >
        <div className={Style.desk_content_box_con}>
          <span className={Style.desk_num_span}>{desk_num_str}</span>
          {desku_info != null ?
            get_desk_use_div()
            :
            get_find_stu_desk_box_button()
          }
        </div>
      </div>
    </div>
  );
};
export default DeskBoxArea;